module.exports = __webpack_public_path__ + "img/img_slogan.5d2f4dc2.png";